import { Component, EventEmitter, Input, OnInit, SimpleChanges } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { FormControl } from '@angular/forms';
import { SubscribedContainer } from '../../util/subscribed-container';
import { CommonModule } from '@angular/common';

export type AllowedRange = {
  min: number;
  max: number;
  minDefault: number;
  maxDefault: number;
  minRange: number;
};

@Component({
  selector: 'jhi-bary-multi-slider',
  templateUrl: './bary-multi-slider.component.html',
  styleUrls: ['./bary-multi-slider.component.scss'],
  standalone: true,
  imports: [NgxSliderModule, CommonModule],
})
export class BaryMultiSliderComponent extends SubscribedContainer implements OnInit {
  @Input() id = '';
  @Input() name: string | undefined;
  @Input() disabled = false;

  @Input() controlStart = new FormControl();
  @Input() controlEnd = new FormControl();
  @Input() updateEvent?: EventEmitter<AllowedRange>;
  @Input() allowedRange: AllowedRange = {
    min: 7,
    max: 19,
    minDefault: 8,
    maxDefault: 18,
    minRange: 3,
  };

  _loaded = false;
  _value!: { timeslotStart: number; timeslotEnd: number };

  sliderOptions?: Options;
  manualRefresh = new EventEmitter();

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['allowedRange']) {
      this.initializeSliderOptions();
    }
  }

  private initializeSliderOptions(): void {
    this.sliderOptions = {
      floor: this.allowedRange.min,
      ceil: this.allowedRange.max,
      minRange: this.allowedRange.minRange,
      showTicks: true,
      minLimit: this.allowedRange.min,
      maxLimit: this.allowedRange.max,
      noSwitching: true,
      translate(value: number) {
        return value + 'h';
      },
    };
  }

  public ngOnInit(): void {
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }

    this._value = {
      timeslotStart: this.controlStart.value ?? this.allowedRange.minDefault,
      timeslotEnd: this.controlEnd.value ?? this.allowedRange.maxDefault,
    };

    // si pas de valeur par défaut on prends la valeurs default.
    if (!this.controlStart.value && !this.controlEnd.value) {
      this.handleChange(this._value);
    }

    if (this.updateEvent) {
      this.updateEvent.subscribe(newVal => this.commitChanges(newVal));
    }

    this._loaded = true;
  }

  // /Do not touch //
  public handleChange(val: any): void {
    this.controlStart.patchValue(val.timeslotStart);
    this.controlEnd.patchValue(val.timeslotEnd);
  }

  public commitChanges(range: AllowedRange): void {
    const options = {
      floor: range.min,
      ceil: range.max,
      minRange: range.minRange,
      minLimit: range.min,
      maxLimit: range.max,
    };

    this.sliderOptions = { ...this.sliderOptions, ...options };
    this.manualRefresh.next();
  }
}
